import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    pictureUrl: "",
    jobTitle: "",
    salesName: "",
    selfIntro:"",
    colorEnum: 0
  },
  getters: {},
  actions: {
    setPictureUrl: function (context, pictureUrl) {
      context.commit("set_PictureUrl", pictureUrl);
    },
    setJobTitle: function (context, jobTitle) {
      context.commit("set_JobTitle", jobTitle);
    },
    setSalesName: function (context, salesName) {
      context.commit("set_SalesName", salesName);
    },
    setSelfIntro: function (context, selfIntro) {
      context.commit("set_SelfIntro", selfIntro);
    },
    setColorEnum: function (context, colorEnum) {
      context.commit("set_ColorEnum", colorEnum);
    },
  },
  mutations: {
    set_PictureUrl: function (state, pictureUrl) {
      state.pictureUrl = pictureUrl;
    },
    set_JobTitle: function (state, jobTitle) {
      state.jobTitle = jobTitle;
    },
    set_SalesName: function (state, salesName) {
      state.salesName = salesName;
    },
    set_SelfIntro: function (state, selfIntro) {
      state.selfIntro = selfIntro;
    },
    set_ColorEnum: function (state, colorEnum) {
      state.colorEnum = colorEnum;
    },
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store_saleBusinessCard.js